import React, { createContext, useContext, useState } from "react";
import { Play, Pause } from "lucide-react";
import { useTTS } from "@/hooks/useTTS";

export const TTSContext = createContext<ReturnType<typeof useTTS> | null>(null);
export const useTTSContext = () => useContext(TTSContext)!;

export const ListenButton = ({ id, text }: { id: string; text: string }) => {
  const { speak, activeId } = useTTSContext();
  const isPlaying = activeId === id;
  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        speak(id, text);
      }}
      className="shrink-0 p-1 rounded-full hover:bg-accent/10 transition-colors text-muted-foreground hover:text-primary"
      title={isPlaying ? "Stop listening" : "Listen to article"}
      aria-label={isPlaying ? "Stop listening" : "Listen to article"}
    >
      {isPlaying ? <Pause className="w-3 h-3" /> : <Play className="w-3 h-3" />}
    </button>
  );
};
